import Base from '../Base';
export default class RefonteTarifaireSingleZone extends Base {
    init(id, main, locale) {
        console.log(':: RefonteTarifaireSingleZone ::');

        var els = document.getElementsByClassName('tableContainer');

        Array.from(els).forEach(el => {
            el.addEventListener('scroll', () => {
                el.classList.add('scrollTable');
            });
        });

        const inputSearch = document.getElementById('myInputSearch');

        if (inputSearch) {
            inputSearch.onkeyup = e => {
                this.searchThroughList(e);
            };
        }

        const Buttons = document.querySelectorAll('.listMuni .single-muni');

        for (const button of Buttons) {
            button.addEventListener('click', e => {
                this.switchZone(e);
            });
        }

        const Anchors = document.getElementsByClassName('single-anchor');
        for (const anchor of Anchors) {
            anchor.addEventListener('click', e => {
                this.scroll(e);
            });
        }

        const scrollTopBtn = document.getElementById('scrollToTop');
        if (scrollTopBtn) {
            scrollTopBtn.addEventListener('click', e => {
                this.scroll(e);
            });
        }

        this.detectParentFAQ();

        this.detectParamMuni();
    }

    scroll(e) {


        e.preventDefault();
        var id = e.currentTarget.getAttribute('href').replace('#', '');
        var target = document.getElementById(id).getBoundingClientRect().top;
        this.animateScroll(target);
    }

    animateScroll(targetHeight, callback) {

        targetHeight = document.body.scrollHeight - window.innerHeight > targetHeight + scrollY
            ? targetHeight : document.body.scrollHeight - window.innerHeight;
        var initialPosition = window.scrollY;
        var SCROLL_DURATION = 30;
        var step_x = Math.PI / SCROLL_DURATION;
        var step_count = 0;
        function step() {
            if (step_count < SCROLL_DURATION) {
                requestAnimationFrame(step);
                step_count++;
                window.scrollTo(0, initialPosition + targetHeight * 0.25 * Math.pow(1 - Math.cos(step_x * step_count), 2));
            } else if (step_count == SCROLL_DURATION) {
                if (typeof callback == 'function') {
                    callback();
                }
            }
        }
        requestAnimationFrame(step);
    }

    switchZone(e) {
        const et = e.target;
        const actives = document.querySelectorAll('.single-muni.active');
        const searchMuni = document.querySelector('.searchMuni');

        if (! searchMuni.classList.contains('openModal')) {
            searchMuni.classList.add('openModal');
        }

        for (const active of actives) {
            active.classList.remove('active');
        }

        et.classList.add('active');

        const allContent = document.querySelectorAll('.single-zone');

        for (const content of allContent) {
            if (content.getAttribute('data-zone') === et.getAttribute('data-zone')) {
                content.style.display = 'block';
            } else {
                content.style.display = 'none';
            }
        }
    }

    searchThroughList(e) {
        var search = e.currentTarget.value.toLowerCase();
        document.querySelectorAll('.single-muni').forEach(row=> {
            var text = row.innerText.toLowerCase();
            if (text.match(search)) {
                row.style.display = 'block';
            } else {
                row.style.display = 'none';
            }
            this.detectParent();
        });
    }

    detectParent() {
        var collectionref = document.querySelectorAll('.listMuni');
        collectionref.forEach(group=>{
            var itemcollection = group.getElementsByClassName('single-muni');
            var hidecounter = 0;
            for (var j = 0; j < itemcollection.length; j++) {
                if (itemcollection[j].style.display === 'none') {
                    hidecounter++;
                }
            }

            if (hidecounter === itemcollection.length) {
                group.style.display = 'none';
            } else {
                group.style.display = 'block';
            }
        });
    }

    detectParentFAQ() {
        var collectionrefFAQ = document.querySelectorAll('.listTheme');
        collectionrefFAQ.forEach(group=>{
            var itemcollectionFAQ = group.getElementsByClassName('singleQuestion');
            var hidecounterFAQ = 0;
            for (var j = 0; j < itemcollectionFAQ.length; j++) {
                if (itemcollectionFAQ[j].style.display === 'none') {
                    hidecounterFAQ++;
                }
            }

            if (hidecounterFAQ === itemcollectionFAQ.length) {
                group.style.display = 'none';
            } else {
                group.style.display = 'block';
            }
        });
    }

    detectParamMuni() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const muniParam = urlParams.get('muni');

        const singleMunis = document.querySelectorAll('.single-muni');

        for (const singleMuni of singleMunis) {
            if (singleMuni.getAttribute('data-id') == muniParam) {
                singleMuni.classList.add('active');
            }
        }

        const active = document.querySelector('.single-muni.active');
        const allContents = document.querySelectorAll('.single-zone');

        const searchMuni = document.querySelector('.searchMuni');

        if (active) {
            if (! searchMuni.classList.contains('openModal')) {
                searchMuni.classList.add('openModal');
            }

            for (const content of allContents) {
                if (content.getAttribute('data-zone') === active.getAttribute('data-zone')) {
                    content.style.display = 'block';
                } else {
                    content.style.display = 'none';
                }
            }

            const topPos = active.offsetTop;
            document.querySelector('.containerMuni').scrollTop = topPos - 10;
        }
    }
}